/**
 * One phone gutter for every role and tab (KAN-1005, RD-DASH-013).
 * On a PHONE (<768) page content sits between max(16px, safe-area inset) on each side.
 * On a TABLET (768-1023, KAN-1006) it is max(20px, safe-area inset). Desktop stays `ui.page.desktopContentPadding`.
 */
export const PHONE_GUTTER_PX = 16;
export const PHONE_GUTTER_LEFT_CSS = `max(${PHONE_GUTTER_PX}px, env(safe-area-inset-left, 0px))`;
export const PHONE_GUTTER_RIGHT_CSS = `max(${PHONE_GUTTER_PX}px, env(safe-area-inset-right, 0px))`;

/** CSS `padding` shorthand (top right bottom left) with the phone gutter on both sides. */
export function phonePagePadding(top, bottom) {
  return `${top} ${PHONE_GUTTER_RIGHT_CSS} ${bottom} ${PHONE_GUTTER_LEFT_CSS}`;
}

export const TABLET_GUTTER_PX = 20;
export const TABLET_GUTTER_LEFT_CSS = `max(${TABLET_GUTTER_PX}px, env(safe-area-inset-left, 0px))`;
export const TABLET_GUTTER_RIGHT_CSS = `max(${TABLET_GUTTER_PX}px, env(safe-area-inset-right, 0px))`;

/** CSS `padding` shorthand (top right bottom left) with the tablet gutter on both sides. */
export function tabletPagePadding(top, bottom) {
  return `${top} ${TABLET_GUTTER_RIGHT_CSS} ${bottom} ${TABLET_GUTTER_LEFT_CSS}`;
}
